module.exports = __webpack_public_path__ + "static/media/cuisine.65af8df3.jpg";